module.exports = {"projectName":"LINKs","copyright":"Copyright © HIBIYA-KADAN All Rights Reserved.","apiURL":"https://develop-links-api.hibiyakadan-wedding.com/mgmt","materialsAndEquipmentAdjustmentListURL":"https://develop-staff-links.hibiyakadan-wedding.com/adjustment/materials_and_equipment_list","deliveryEvaluationURL":"https://develop-partner-links.hibiyakadan-wedding.com/delivery_evaluation"}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = QkNq
// module chunks = 1